import { APSpinner } from '@shared/components/atoms/spinner/index';

import type { FC } from 'react';

export const APLoading: FC<{ message?: string }> = ({ message }) => {
  return (
    <div className="ap-loading" style={{ height: '100vh', width: '100vw' }}>
      <APSpinner aria-label={message ?? 'Loading...'} size="large" />
      {message && <span className="ap-muted">{message}</span>}
    </div>
  );
};

export default APLoading;
